// extracted by mini-css-extract-plugin
module.exports = {"signOutButton":"sign-out-button_signOutButton__g1LH7","icon":"sign-out-button_icon__1IIJa"};